/**
 * 配置编译环境和线上环境之间的切换 LYJ
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址
 * https://apitest.canpoint.net
 */
const apiUrl = "openapi";
const pageSize = 10;
const appid = "wx773a40341606402b"; //二维码登录appid
const aeskey = "abc1f31af84dfc009a032f169784f964";
const fileUpload = "/weixins/wenjiao/fileUpload";
const uploadImageUrl = "/openapi/api/upload/image";
const wxPicUploadUrl = "/weixins/wenjiao/webPicUpload"; // 图片上传地址
const editorUploadImageUrl = "/openapi/api/upload/editorImage";
const xueTangOpenHeaders = {
  appid: "30503640",
  appkey: "30516143036406038519810597",
};
const prefix = "mf_100_";
const yunPingTaiConfig = {
  accessKeyID: "8ae45544-392c-4e43-be48-2dff825fb938",
  accessKeySecret: "b9bfa3ab-d5a8-4c26-9566-c9e59fb5bd0d",
  appKey: "b759efd8faa7d7ebacfdf3e412767458",
  appSecret: "835898768744b3c96a6269ea3e11eca0",
};
export {
  apiUrl,
  pageSize,
  aeskey,
  uploadImageUrl,
  editorUploadImageUrl,
  xueTangOpenHeaders,
  fileUpload,
  yunPingTaiConfig,
  wxPicUploadUrl,
  appid,
  prefix,
};
